export class OrganizationDOA {
  Id: string
  WorkflowType: string
  GroupCodeDOA: string
  OrganizationCode: string
  MaxPositionLevel: number
  ActionId: number
  SequenceApprove: number
  FlagActive: string
  FlagDelete: string
  CreateDate: string
  CreateBy: string
  UpdateDate: string
  UpdateBy: string
}
